import React, { useCallback, useState } from 'react';
import { ScreenWrapper } from '../../components/Wrappers/ScreenWrapper';

import { useNavigate } from 'react-router';
import { ERoutes } from '../../enums';
import { useGameStore } from '../../stores';
import { useCompetitionMode } from '../CompetitionModeScreen/useCompetitionMode';
import CompetitionModeResultModal from '../../components/Modals/CompetitionModeResultModal/CompetitionModeResultModal';
import { HippoFactModal } from '../../components/Modals/HippoFactModal/HippoFactModal';

const FinalizeCompetitionScreen: React.FC = () => {
  const navigate = useNavigate();

  const handleBack = useCallback(() => {
    navigate(ERoutes.gameModes);
  }, [navigate]);

  const [showResultModal, setShowResultModal] = useState(true);
  const [showHippoFactModal, setShowHippoFactModal] = useState(false);

  const handleResultModalClose = useCallback(
    () => setShowResultModal(false),
    [],
  );

  const { disableTries } = useCompetitionMode();
  const distance = useGameStore(
    (state) => state.competitionModeStatus?.lastAttemptDistance,
  );

  const score = useGameStore(
    (state) => state.competitionModeStatus?.lastAttemptScore,
  );
  const attempts = useGameStore(
    (state) => state.competitionModeStatus?.attempts,
  );

  return (
    <ScreenWrapper onBack={handleBack} isAbsolute>
      <CompetitionModeResultModal
        open={showResultModal}
        handleClose={handleResultModalClose}
        disableTries={disableTries}
        score={score}
        distance={distance}
        attempts={attempts}
        setShowHippoFactModal={setShowHippoFactModal}
        setShowResultModal={setShowResultModal}
      />
      <HippoFactModal
        showHippoFactModal={showHippoFactModal}
        setShowHippoFactModal={setShowHippoFactModal}
      />
    </ScreenWrapper>
  );
};

export default FinalizeCompetitionScreen;
